import React, { useState, useEffect, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { AppContext } from '../../../App'
import Spinner from '../../../components.js/elements/Spinner'
import ModalStaff from '../../../components.js/serveur/staff/ModalStaff'
import ModalStaffServices from '../../../components.js/serveur/staff/ModalStaffServices'
import ViewStaff from '../../../components.js/serveur/staff/ViewStaff'
import useFirebase from '../../../firebase/useFirebase'
import useForm from '../../../hooks/useForm' 
import HeaderReturn from './../../../components.js/serveur/siteWeb/HeaderReturn'
// IMAGES
import imageClients from '../../../images/clients.png'
import ModalConfirm from '../../../components.js/modal/ModalConfirm'

const INITIAL_STATE = {
    nameStaff:'',
    surnameStaff:'',
    circleColor:1,
    phoneStaff:'',
}

const VALUES_STAFF = {
    idStaff:'',
    nameStaff:'',
    surnameStaff:'',
    phoneStaff:'',
}
 
const Staff = () => {
    const { user } = useContext(AppContext)
    const [montage, setMontage] = useState(true)
    const { handleChange, values, refresh, setValues } = useForm(INITIAL_STATE)
    const { writeData, deleteData, updateData, readData, staff, services } = useFirebase()
    const [valuesStaff, setValuesStaff] = useState(VALUES_STAFF)
    const [count, setCount] = useState(0)
    let navigate = useNavigate()

    useEffect(() => { 
        readData(user.uid)
        window.scrollTo(0, 0)
        setMontage(false)
    },[])

    useEffect(() => {
        console.log('Staff useEffect ', count)
        refresh()
    },[count])

    if (montage) return <Spinner />

    const handleAddStaff = (surnameStaff, nameStaff, circleColor, phoneStaff) => {
        let name = nameStaff.toUpperCase()
        let surname = surnameStaff.charAt(0).toUpperCase() + surnameStaff.slice(1)
        console.log('Staff handleAddStaff ', name, surname)
        const data = {surnameStaff:surname, nameStaff:name, circleColor:circleColor, phoneStaff: phoneStaff ? phoneStaff : '' ,doc:'docStaff', nbrWeeks:4}
        writeData('entreprises/'+user.uid+'/staff',data)
        refresh()
    } 

    const _handleDelete = () => {
        deleteData('entreprises/'+user.uid+'/staff/'+valuesStaff.idStaff)
    }

    const handleSelectService = (id, idStaff, idService) => {
        const ifSelect = idService === true ? false : true
        const data = {[idStaff]:ifSelect}
        updateData('entreprises/'+user.uid+'/services/'+id,data) 

    }
 
    return (
        <div className='container-fluid'> 
            <HeaderReturn 
                title='Equipe'  
                link='/homeServeur'
                image={imageClients}  
            />
            <ViewStaff
                staff={staff}
                setValuesStaff={setValuesStaff}
                services={services}
            />
            <ModalStaff
                handleChange={handleChange} 
                handleAddStaff={handleAddStaff}
                values={values}
                setValues={setValues}
                setCount={setCount}
                count={count}
            />
            <ModalStaffServices
                services={services}
                valuesStaff={valuesStaff}
                handleSelectService={handleSelectService}
                staff={staff}
            />
            <ModalConfirm
                title="Êtes vous sur de vouloir supprimer l'équipier ?"
                _handleModal={_handleDelete}
            />
        </div>
    )
}

export default Staff
